/**
 * Builds a Windows-safe contract PDF filename (no spaces → avoids %20 in saved names).
 * @param {string|number|undefined|null} orderId
 * @returns {string}
 */
export function buildContractPdfFilename(orderId) {
  const raw = String(orderId ?? '')
    .trim()
    .replace(/\s+/g, '')
    .replace(/%/g, '');
  const stem = raw.replace(/[<>:"/\\|?*]/g, '_').slice(0, 32) || 'servicio';
  return `Contrato_AutoGo_${stem}.pdf`;
}
